export const EKG_QT_STATUS = {
  NOT_STARTED: 'Not Requested',
  PENDING: 'Pending',
  COMPLETE: 'Completed',
  SENT: 'Sent',
};
export const EKG_QT_ERROR = {
  OTHER: 'Other',
  POORQUALITY: 'Poor Quality',
  UNDETERMINEDRHYTHM: 'Undetermined Rhythm',
};



// WEBPACK FOOTER //
// ./src/state/reducers/ekgRecordings/constants.js